import { Role } from '@traton/devportal-rbac-common-lib';

// Name must exactly match the Azure Entra ID app role Value field.
export const portalUser: Role = {
  name: 'portal.user',
  description: 'User role for the developer portal',
};
